"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h2", [_vm._v("BasisIcon")]), _c("ul", [_c("li", [_vm._v("该组件集成Ant Design Vue 的 Icon 组件所有属性和事件。")]), _c("li", [_vm._v("该组件已全局注册")])]), _c("h3", [_vm._v("Usage")]), _c("pre", {
    pre: true
  }, [_c("code", {
    pre: true,
    attrs: {
      "v-pre": "",
      class: "language-vue"
    }
  }, [_vm._v('<template>\n  <!-- 使用 antd 默认图标 -->\n  <basis-icon type="home"></basis-icon>\n  <!-- 使用本地svg图标，存放在 “./icons”目录下，type就是svg文件的名称 -->\n  <basis-icon type="logo" attr="component" :size="24"></basis-icon>\n  <!-- 使用 iconfont 图标，如果是以"icon-"，可不写 attr="iconfont" -->\n  <basis-icon type="icon-edit" attr="iconfont"></basis-icon>\n  <!-- 使用 antd 默认图标 自定义样式 -->\n  <basis-icon type="home" :style="{fontSize: \'120px\'}"></basis-icon>\n  <!-- 设置外边距 -->\n  <basis-icon type="logo" attr="component" :size="24" :mt="8" :mr="8" :mb="8" :ml="8"></basis-icon>\n</template>\n')])])])])]);
}];
render._withStripped = true;